import React from 'react'
import '../App.css'

const reviewcard = ({ name, text, rating }) => (
    <div className="review-card">
      <span className="review-name">{name}</span>
      <br />
      <span className="review-card-text">"{text}"</span>
      <br />
      <div className="review-stars">
        {[...Array(5)].map((_, i) => (
          <span key={i} className="star">{i < rating ? "★" : "☆"}</span>
        ))}
      </div>
    </div>
);
export default reviewcard